import { ChangeDetectionStrategy, Component, OnInit, TrackByFunction } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ACCOUNT_PATH, MODAL_ROUTES, PAYMENTS_PATH } from '@woolworthsnz/shop';
import {
	FeatureService,
	HistoryService,
	ModalRoutingService,
	NotificationType,
	RoutedModalBaseComponent,
	TrackingEvent,
	ButtonComponent,
	SlottedModalComponent,
	TrackEventDirective,
	SvgIconComponent,
	PaymentInstrumentComponent,
	PaymentStoreService,
} from '@woolworthsnz/styleguide';
import { CardInstrument } from '@woolworthsnz/trader-api';
import { Observable } from 'rxjs';
import { PaymentDirectDebitComponent } from '../payment-direct-debit/payment-direct-debit.component';
import { NgFor, NgIf, AsyncPipe } from '@angular/common';

@Component({
	selector: 'wnz-payment-list-modal',
	templateUrl: './payment-list-modal.component.html',
	styleUrls: ['./payment-list-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		SlottedModalComponent,
		NgFor,
		TrackEventDirective,
		PaymentInstrumentComponent,
		NgIf,
		ButtonComponent,
		PaymentDirectDebitComponent,
		SvgIconComponent,
		AsyncPipe,
	],
})
export class PaymentListModalComponent extends RoutedModalBaseComponent implements OnInit {
	addNewCardDescription = 'Add new credit or debit card';
	savedInstruments$: Observable<CardInstrument[]>;
	directDebitEnabled$: Observable<boolean>;
	trackingEvent = TrackingEvent;
	notificationType = NotificationType;

	/**
	 * Since the application is modular with multiple potential auxiliary router outlets (depending on the module
	 * where this modal component is being used from), determine to which modal router outlet the "delete confirmation modal"
	 * needs to go based on the current URL
	 * @protected
	 */
	protected get modalOutlet(): string {
		// Mostly used from the /checkout/payments module
		if (this.router.url.includes(PAYMENTS_PATH)) {
			return MODAL_ROUTES.PAYMENT_MODAL;
		}

		if (this.router.url.includes(ACCOUNT_PATH)) {
			return MODAL_ROUTES.ACCOUNT_MODAL_OUTLET;
		}

		return MODAL_ROUTES.DELIVERY_MODAL_OUTLET;
	}

	constructor(
		router: Router,
		protected activatedRoute: ActivatedRoute,
		historyService: HistoryService,
		protected paymentStore: PaymentStoreService,
		protected modalRoutingService: ModalRoutingService,
		protected featureService: FeatureService
	) {
		super(router, activatedRoute, historyService);
	}

	ngOnInit(): void {
		this.savedInstruments$ = this.paymentStore.select('savedPaymentInstruments');
		this.directDebitEnabled$ = this.paymentStore.select('directDebitEnabled');
	}

	trackByFn: TrackByFunction<CardInstrument> = (_, instrument) => instrument.id;

	handleSavedInstrumentClick(instrument: CardInstrument): void {
		this.paymentStore.setInstrument(instrument, true);
		this.close();
	}

	delete(event: Event, instrumentId: string): void {
		event.stopImmediatePropagation();
		this.modalRoutingService.open(this.modalOutlet, MODAL_ROUTES.DELETE_CREDIT_CARD, instrumentId);
	}

	addNew(): void {
		this.paymentStore.clearCurrentInstrument(true);
		this.close();
	}

	handleDirectDebitClick(): void {
		this.paymentStore.setDirectDebit();
		this.close();
	}
}
